import React from 'react';
import SitePage, { SectionHeader } from './SiteChrome';

// Studio (spec §7): the about page. One column of editorial text, one
// portrait/studio image placeholder. Copy is final.

export default function Studio() {
  return (
    <SitePage>
      <section className="ac-section">
        <div className="ac-wrap">
          <SectionHeader kicker="Studio" title="About Anastasia & Co." />
          <div style={{ display: 'grid', gap: 'clamp(28px, 5vw, 56px)', gridTemplateColumns: 'minmax(0, 65ch) minmax(200px, 1fr)', alignItems: 'start' }}>
            <div className="ac-case-body">
              <p className="ac-dropcap ac-reveal">
                Anastasia &amp; Co. is a small studio for brands that need more than
                a logo file and a leftover website. We handle the work that makes a
                business look finished: identity, websites and apps, photography,
                copy, and the advertising that carries it.
              </p>
              <p className="ac-reveal" style={{ '--d': '0.12s', fontFamily: 'var(--ac-serif)', fontSize: '1.25rem', color: 'var(--ac-sea)' }}>
                One point of view. One set of standards. No patchwork.
              </p>
              <p className="ac-reveal" style={{ '--d': '0.2s' }}>
                Most studios hand you one piece and wish you luck with the rest. We
                stay for the whole picture — because a brand isn’t a deliverable,
                it’s the sum of every place someone meets you.
              </p>
            </div>
            <div className="ac-studio-media ac-reveal-wipe">
              <img src="/ext/media/studio-interior.jpg" alt="The studio: a sun-lit worktable by a window on the sea" loading="lazy" />
            </div>
          </div>
        </div>
      </section>
    </SitePage>
  );
}
